import type { ReactNode } from "react";
import { OfflineBanner } from "./OfflineBanner.js";

export interface SurfaceShellProps {
  readonly children: ReactNode;
  readonly testId?: string;
  readonly className?: string;
  readonly onRetry?: () => void;
  readonly maxWidthClassName?: string;
  /** Sticky white chrome strip above the working surface. */
  readonly chrome?: ReactNode;
  /** Drop the outer padding and max width — the surface manages its own frame. */
  readonly bleed?: boolean;
}

export function SurfaceShell(props: SurfaceShellProps) {
  const maxW = props.bleed ? "" : (props.maxWidthClassName ?? "max-w-[1600px]");
  const bodyClass = props.bleed
    ? "flex w-full min-h-0 min-w-0 flex-1 flex-col"
    : `mx-auto flex w-full min-h-0 min-w-0 flex-1 flex-col gap-3 p-3 sm:p-4 ${maxW}`;
  return (
    <div
      className={`flex min-h-screen w-full min-w-0 flex-col overflow-x-hidden bg-pad-100 ${props.className ?? ""}`}
      data-testid={props.testId}
    >
      {props.chrome ? (
        <div className="sticky top-0 z-20 border-b border-pad-200 bg-white">
          <div className={`mx-auto w-full min-w-0 ${props.bleed ? "" : `px-3 sm:px-4 ${maxW}`}`}>
            {props.chrome}
          </div>
        </div>
      ) : null}
      <div className={bodyClass}>
        <OfflineBanner {...(props.onRetry ? { onRetry: props.onRetry } : {})} />
        {props.children}
      </div>
    </div>
  );
}
